<div>
    <img [src]="imageUrl" />
    <h2>{{ title }}</h2>
    <p *ngFor="let text of textLines">{{ text }}</p>
</div>